export const translations = {
  de: {
    nav: {
      home: "Start",
      services: "Leistungen & Preise",
      tech: "Technologie",
      gallery: "Galerie",
      contact: "Kontakt",
      cta: "Termin buchen",
    },
    hero: {
      eyebrow: "Premium Cleaning & Facility",
      title_1: "Premium Reinigung",
      title_2: "in Valposchiavo & Engadin.",
      subtitle:
        "Präzision, Sauberkeit und absolute Zuverlässigkeit. Leaner bietet professionelle Reinigungslösungen für Privatimmobilien, Ferienwohnungen und Gewerbeflächen in Valposchiavo, St. Moritz und dem gesamten Oberengadin.",
      philosophy:
        "Wir haben das Unternehmen Leaner genannt, weil wir die Lean-Philosophie in die Reinigung bringen: keine überflüssigen Bewegungen, keine verlorene Zeit des Kunden, nur maximale Effizienz und deutsche Präzision mit erstklassiger Ausrüstung.",
      cta_primary: "Termin buchen",
      cta_secondary: "Kontakt via WhatsApp",
      philosophyLabel: "Unsere Philosophie",
    },
    services: {
      overline: "Leistungen & Preise",
      title: "Klare Preise. Erstklassige Ausführung.",
      subtitle:
        "Vier transparente Pakete für Eigentümer, die Qualität und Diskretion erwarten.",
      items: [
        {
          name: "Stundenreinigung",
          price: "48 CHF",
          unit: "/ Stunde",
          desc: "Absolute Diskretion und Sicherheit für Ihre Innenräume. Mit erstklassiger Kärcher-Ausrüstung und PH-neutraler Chemie zum Schutz Ihres Eigentums.",
          features: [
            "Kärcher- & Profi-Geräte",
            "PH-neutrale Chemie",
            "Flexible Einsätze",
          ],
        },
        {
          name: "Mobile Fahrzeugreinigung",
          price: "45 CHF",
          unit: "pauschal",
          desc: "Express Aufbereitung vor Ort. Tiefenreinigung von Innenraum, Karosserie, Scheiben und Kofferraum — direkt vor Ihrer Tür.",
          features: [
            "Vor Ort beim Kunden",
            "Innen- & Außenbereich",
            "Detail-Politur",
          ],
        },
        {
          name: "Der 'Leaner' Komplex",
          price: "240 CHF",
          unit: "/ Besuch",
          desc: "Haus + Fahrzeug + Fassade/Pflasterung. Ein kompletter 4.5–5 Std. Property-Reset für Eigentümer, die makellose Ausführung schätzen.",
          features: [
            "Komplettes Innen-Setup",
            "Fahrzeugpflege inklusive",
            "Fassade oder Pflastersteine",
          ],
          highlight: true,
          badge: "Beliebt",
        },
        {
          name: "Monats-Abonnement",
          price: "490 CHF",
          unit: "/ Monat",
          desc: "Dauerhafte Sorgenfreiheit für Ihre Immobilie. Wöchentliche Hauspflege sowie abwechselnde Fahrzeug-/Außenreinigung inklusive.",
          features: [
            "Wöchentlicher Besuch",
            "Priorisierte Verfügbarkeit",
            "Persönlicher Ansprechpartner",
          ],
        },
      ],
      note: "Keine Anfahrtskosten in Valposchiavo. Region Engadin / St. Moritz: + 35 CHF Fixpauschale pro Besuch.",
      commercial: {
        eyebrow: "Für Unternehmen",
        name: "Gewerbe & Unternehmen",
        priceLabel: "Auf Anfrage",
        priceHint: "Vertrag nach Volumen",
        desc: "Massgeschneiderte Reinigungsverträge für Hotels, Boutiquen, Restaurants, Büros und Mehrfamilien-Immobilien. Wir passen Frequenz, Team-Grösse und Service-Umfang an Ihren Betrieb an.",
        features: [
          "Individueller Vertrag",
          "Geplante Frequenz nach Bedarf",
          "Dediziertes Team & Ansprechpartner",
          "Rechnungsstellung mit MwSt.",
        ],
        cta: "Angebot anfragen",
      },
    },
    tech: {
      overline: "Technologie & Materialien",
      title: "Kompetenz für edle Oberflächen.",
      subtitle:
        "Jedes Material erhält die exakt richtige Chemie und den richtigen Druck.",
      items: [
        {
          title: "Echtholz & Parkett",
          desc: "Keinerlei Alkalien, kontrollierte Feuchtigkeit zum Schutz vor Quellung.",
        },
        {
          title: "Marmor & Travertin",
          desc: "100% säurefreier Ansatz zum Schutz des natürlichen Steinglanzes.",
        },
        {
          title: "Panoramafenster",
          desc: "Streifenfreies Finish und schonende Rahmenpflege.",
        },
        {
          title: "Pflastersteine",
          desc: "Tiefenreinigung mit Profi-Hochdruck zur Entfernung von Moos und Witterungsspuren.",
        },
      ],
    },
    gallery: {
      overline: "Vorher / Nachher",
      title: "Bewegen Sie den Cursor über das Bild.",
      subtitle:
        "Eine klare, ehrliche Darstellung unserer Arbeit. Kein Filter, keine Inszenierung.",
      before: "Vorher",
      after: "Nachher",
      hint: "Hover, um das Ergebnis zu sehen",
    },
    contact: {
      overline: "Kontakt",
      title: "Sprechen wir über Ihr Objekt.",
      subtitle:
        "Schnellste Antwort über WhatsApp oder Telegram. Oder hinterlassen Sie uns eine kurze Nachricht.",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      formHeading: "Anfrage senden",
      formIntro: "Wir melden uns innerhalb von wenigen Stunden zurück.",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefonnummer",
        location: "Ort (Stadt / Dorf)",
        message: "Ihre Nachricht",
        messagePlaceholder: "Wie können wir Ihnen helfen? Objekt, Wünsche, gewünschter Termin…",
        submit: "Anfrage senden",
        sending: "Wird gesendet…",
        contactHint: "E-Mail oder Telefon — mindestens eines wird benötigt",
        subject: "Neue Anfrage von der Webseite Leaner",
      },
      toast: {
        success: "Anfrage gesendet — wir melden uns innerhalb von wenigen Stunden.",
        error: "Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
        validation: "Bitte E-Mail oder Telefonnummer angeben.",
      },
    },
    footer: {
      tagline: "Premium Cleaning & Facility — Valposchiavo & Engadin.",
      hours: "Arbeitszeiten",
      hoursValue: "Mo – Sa · 08:00 – 19:00",
      privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services & Pricing",
      tech: "Technology",
      gallery: "Gallery",
      contact: "Contact",
      cta: "Book a Visit",
    },
    hero: {
      eyebrow: "Premium Cleaning & Facility",
      title_1: "Premium cleaning services",
      title_2: "in Valposchiavo & Engadin.",
      subtitle:
        "Precision, cleanliness and absolute reliability. Leaner delivers professional cleaning solutions for private residences, holiday apartments and commercial spaces in Valposchiavo, St. Moritz and the entire Upper Engadin.",
      philosophy:
        "We named the company Leaner because we bring the Lean philosophy to cleaning: no wasted movements, no wasted client time, only maximum efficiency and German precision using top equipment.",
      cta_primary: "Book a Visit",
      cta_secondary: "Contact on WhatsApp",
      philosophyLabel: "Our Philosophy",
    },
    services: {
      overline: "Services & Pricing",
      title: "Clear pricing. Flawless execution.",
      subtitle:
        "Four transparent packages for owners who expect quality and discretion.",
      items: [
        {
          name: "Hourly Cleaning",
          price: "48 CHF",
          unit: "/ hour",
          desc: "Absolute discretion and safety for your interiors. Using top-tier Kärcher equipment and PH-neutral chemistry to protect your belongings.",
          features: [
            "Kärcher & pro-grade tools",
            "PH-neutral chemistry",
            "Flexible scheduling",
          ],
        },
        {
          name: "Mobile Car Cleaning",
          price: "45 CHF",
          unit: "flat",
          desc: "Express on-site detailing. Deep cleaning of interior, panels, windows, and trunk right at your doorstep.",
          features: [
            "At your location",
            "Interior & exterior",
            "Detail finish",
          ],
        },
        {
          name: "The 'Leaner' Complex",
          price: "240 CHF",
          unit: "/ visit",
          desc: "House + Car + Facade/Paving. A complete 4.5–5 hour property reset for owners who value flawless execution.",
          features: [
            "Full interior set",
            "Vehicle care included",
            "Facade or paving wash",
          ],
          highlight: true,
          badge: "Most Chosen",
        },
        {
          name: "Monthly Subscription",
          price: "490 CHF",
          unit: "/ month",
          desc: "Continuous peace of mind for your property. Includes weekly house maintenance and alternating car/exterior washing.",
          features: [
            "Weekly visit",
            "Priority availability",
            "Dedicated contact",
          ],
        },
      ],
      note: "Zero transport fee for Valposchiavo. Engadin / St. Moritz region: + 35 CHF fixed transport fee per visit.",
      commercial: {
        eyebrow: "For businesses",
        name: "Commercial & Business",
        priceLabel: "On request",
        priceHint: "Contract based on volume",
        desc: "Tailored cleaning contracts for hotels, boutiques, restaurants, offices and multi-unit properties. We adapt frequency, team size and scope to your operation.",
        features: [
          "Custom contract",
          "Scheduled frequency to fit your needs",
          "Dedicated team & account manager",
          "VAT invoicing",
        ],
        cta: "Request a quote",
      },
    },
    tech: {
      overline: "Technology & Materials",
      title: "Expertise for noble surfaces.",
      subtitle:
        "Each material gets exactly the right chemistry and the right pressure.",
      items: [
        {
          title: "Natural Wood & Parquet",
          desc: "Zero alkaline, controlled moisture to prevent wood swelling.",
        },
        {
          title: "Marble & Travertine",
          desc: "100% acid-free approach to protect the natural stone gloss.",
        },
        {
          title: "Panoramic Windows",
          desc: "Streak-free finish and gentle frame care.",
        },
        {
          title: "Paving Stones",
          desc: "Deep high-pressure washing to remove moss and restore the original look.",
        },
      ],
    },
    gallery: {
      overline: "Before / After",
      title: "Hover over the image.",
      subtitle: "An honest look at our work. No filters, no staging.",
      before: "Before",
      after: "After",
      hint: "Hover to see the result",
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your property.",
      subtitle:
        "Fastest reply via WhatsApp or Telegram. Or leave us a quick note below.",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      formHeading: "Send Request",
      formIntro: "We'll get back to you within a few hours.",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone number",
        location: "Location (city / village)",
        message: "Your message",
        messagePlaceholder: "How can we help? Property, expectations, preferred date…",
        submit: "Send Request",
        sending: "Sending…",
        contactHint: "Email or phone — at least one is required",
        subject: "New request from Leaner website",
      },
      toast: {
        success: "Request sent — we'll get back to you within a few hours.",
        error: "Could not send. Please retry or message us on WhatsApp.",
        validation: "Please provide an email or a phone number.",
      },
    },
    footer: {
      tagline: "Premium Cleaning & Facility — Valposchiavo & Engadin.",
      hours: "Working hours",
      hoursValue: "Mon – Sat · 08:00 – 19:00",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
    },
  },

  it: {
    nav: {
      home: "Home",
      services: "Servizi & Prezzi",
      tech: "Tecnologia",
      gallery: "Galleria",
      contact: "Contatti",
      cta: "Prenota una visita",
    },
    hero: {
      eyebrow: "Servizi di Pulizia Professionali",
      title_1: "Servizi di pulizia premium",
      title_2: "in Valposchiavo & Engadina.",
      subtitle:
        "Precisione, pulizia e affidabilità assoluta. Leaner offre soluzioni di pulizia professionali per residenze private, appartamenti di vacanza e spazi commerciali in Valposchiavo, St. Moritz e in tutta l'Alta Engadina.",
      philosophy:
        "Abbiamo chiamato l'azienda Leaner perché portiamo la filosofia Lean nella pulizia: nessun movimento sprecato, nessun tempo perso al cliente, solo massima efficienza e precisione tedesca con attrezzatura di prim'ordine.",
      cta_primary: "Prenota una visita",
      cta_secondary: "Scrivici su WhatsApp",
      philosophyLabel: "La nostra filosofia",
    },
    services: {
      overline: "Servizi & Prezzi",
      title: "Prezzi chiari. Esecuzione impeccabile.",
      subtitle:
        "Quattro pacchetti trasparenti per proprietari che esigono qualità e discrezione.",
      items: [
        {
          name: "Pulizia a Ore",
          price: "48 CHF",
          unit: "/ ora",
          desc: "Discrezione e sicurezza assolute per i tuoi interni. Attrezzatura Kärcher di alto livello e chimica PH-neutra per proteggere i tuoi beni.",
          features: [
            "Kärcher e strumenti pro",
            "Chimica PH-neutra",
            "Pianificazione flessibile",
          ],
        },
        {
          name: "Lavaggio Auto Mobile",
          price: "45 CHF",
          unit: "forfait",
          desc: "Detailing espresso sul posto. Pulizia profonda di interni, carrozzeria, vetri e bagagliaio — direttamente a casa tua.",
          features: [
            "Direttamente da te",
            "Interno ed esterno",
            "Finitura di dettaglio",
          ],
        },
        {
          name: "Il Complesso 'Leaner'",
          price: "240 CHF",
          unit: "/ visita",
          desc: "Casa + Auto + Facciata/Pavimentazione. Un reset completo dell'immobile in 4.5–5 ore per chi pretende un'esecuzione impeccabile.",
          features: [
            "Set interno completo",
            "Cura del veicolo inclusa",
            "Facciata o pavimentazione",
          ],
          highlight: true,
          badge: "Il più scelto",
        },
        {
          name: "Abbonamento Mensile",
          price: "490 CHF",
          unit: "/ mese",
          desc: "Tranquillità continua per il tuo immobile. Manutenzione settimanale della casa e lavaggio auto/esterni alternati inclusi.",
          features: [
            "Visita settimanale",
            "Disponibilità prioritaria",
            "Referente dedicato",
          ],
        },
      ],
      note: "Trasporto gratuito in Valposchiavo. Regione Engadina / St. Moritz: + 35 CHF di trasporto fisso per visita.",
      commercial: {
        eyebrow: "Per le aziende",
        name: "Aziende & Commerciale",
        priceLabel: "Su richiesta",
        priceHint: "Contratto in base ai volumi",
        desc: "Contratti di pulizia su misura per hotel, boutique, ristoranti, uffici e immobili plurifamiliari. Adattiamo frequenza, dimensione del team e ambito del servizio alla tua attività.",
        features: [
          "Contratto personalizzato",
          "Frequenza pianificata su misura",
          "Team e referente dedicati",
          "Fatturazione con IVA",
        ],
        cta: "Richiedi un preventivo",
      },
    },
    tech: {
      overline: "Tecnologia & Materiali",
      title: "Competenza per superfici nobili.",
      subtitle: "Ogni materiale riceve la chimica e la pressione esatte.",
      items: [
        {
          title: "Legno Naturale & Parquet",
          desc: "Zero alcali, umidità controllata per evitare il rigonfiamento del legno.",
        },
        {
          title: "Marmo & Travertino",
          desc: "Approccio 100% acid-free per proteggere la lucentezza naturale della pietra.",
        },
        {
          title: "Vetrate Panoramiche",
          desc: "Finitura senza aloni e cura delicata dei telai.",
        },
        {
          title: "Pavimentazioni in Pietra",
          desc: "Idropulitura profonda ad alta pressione: rimuove muschio e riporta l'originario aspetto.",
        },
      ],
    },
    gallery: {
      overline: "Prima / Dopo",
      title: "Passa il cursore sull'immagine.",
      subtitle:
        "Uno sguardo onesto al nostro lavoro. Nessun filtro, nessuna messa in scena.",
      before: "Prima",
      after: "Dopo",
      hint: "Passa il cursore per vedere il risultato",
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo del tuo immobile.",
      subtitle:
        "Risposta più veloce via WhatsApp o Telegram. Oppure lasciaci una breve nota.",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      formHeading: "Invia richiesta",
      formIntro: "Ti rispondiamo entro poche ore.",
      form: {
        name: "Nome",
        email: "E-mail",
        phone: "Numero di telefono",
        location: "Località (città / paese)",
        message: "Il tuo messaggio",
        messagePlaceholder: "Come possiamo aiutarti? Immobile, aspettative, data preferita…",
        submit: "Invia richiesta",
        sending: "Invio in corso…",
        contactHint: "E-mail o telefono — almeno uno è richiesto",
        subject: "Nuova richiesta dal sito Leaner",
      },
      toast: {
        success: "Richiesta inviata — ti risponderemo entro poche ore.",
        error: "Invio non riuscito. Riprova o scrivici su WhatsApp.",
        validation: "Inserisci un'e-mail o un numero di telefono.",
      },
    },
    footer: {
      tagline: "Premium Cleaning & Facility — Valposchiavo & Engadina.",
      hours: "Orari di lavoro",
      hoursValue: "Lun – Sab · 08:00 – 19:00",
      privacy: "Privacy",
      rights: "Tutti i diritti riservati.",
    },
  },
};

export const SUPPORTED_LANGS = ["de", "en", "it"];
export const DEFAULT_LANG = "de";
